<template>
  <Flex
    direction="column"
    :class="$style.base"
  >
    <BaseText
      iconBefore="arrow-left"
      @click="navBack"
      v-test="'backToEmails'"
    >
      {{ $t('global.back') }}
    </BaseText>

    <Flex
      direction="column"
      :gap="0.5"
    >
      <BaseHeading>{{ title }}</BaseHeading>
      <BaseText>{{ description }}</BaseText>
    </Flex>
    <BaseToggle
      v-if="showToggle && $route.name !== 'rebook-reminder-template'"
      v-model="enabled"
      :label="enabled ? $t('global.enabled') : $t('global.disabled')"
      v-test="'intro-toggle'"
    />
  </Flex>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { useMarketingBuilderStore } from '../../store/builder';
import { useNavBack } from '../useNavBack';

export default defineComponent({
  setup() {
    const { navBack } = useNavBack();
    const builderStore = useMarketingBuilderStore();
    const { title, showToggle, description, emailType } =
      storeToRefs(builderStore);
    return { navBack, title, showToggle, description, emailType, builderStore };
  },
  computed: {
    enabled: {
      get() {
        return this.builderStore.enabled;
      },
      set() {
        this.builderStore.setEnabled(!this.enabled);
      },
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  margin-right: auto;
}
</style>
